module.exports = __webpack_public_path__ + "img/screen-img-01.eef014af.jpeg";